import React from 'react';

// Hidden box that people never see or fill. Form-filling bots usually fill every input,
// so a value here marks the enquiry as spam (checked on the server). No captcha needed.
export default function HoneyPot() {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
      <label>Leave this empty<input type="text" name="vk_website" tabIndex={-1} autoComplete="off" defaultValue="" /></label>
    </div>
  );
}
